<div class="info-course">
    <div class="actions-meeting">
        <a class="btn btn-back" routerLink="/list-games">
            <img src="images/svg/arrow-right.svg" alt="">
        </a>
        <select name="" id="" [(ngModel)]="selectedMeetingId" (ngModelChange)="meetingChange($event)">
            <option [value]="-1">{{'select.meeting' | translate}}</option>
            @for (meeting of meetings; track $index) {
                <option [value]="meeting.id" [selected]="meeting.id === selectedMeetingId">{{ meeting.name }}</option>
            }
        </select>
    </div>
    <div class="action-course">
        <button class="btn l-btn" (click)="previousRace()" [disabled]="currentIndex === 0">
            <img src="images/svg/chevron-left.svg" alt="">
        </button>

        <div class="course" *ngIf="currentRace">
            <h2>{{ 'race.singular' | translate}} {{ currentRace.id }}</h2>
            <h3>{{ currentRace.name }}</h3>
            <p>{{ currentRace.date| date:"HH:MM" }} - {{ currentRace.type }} - {{ (currentRace.horses?.length || 0) }} {{'horse.plural' | translate}} -
                {{currentRace.distance}}</p>
        </div>
        <button class="btn r-btn" (click)="nextRace()" [disabled]="currentIndex === races.length - 1">
            <img src="images/svg/chevron-right.svg" alt="">
        </button>
    </div>
</div>
